module.exports = __webpack_public_path__ + "img/butterfly.9a26bb81.jpg";